import * as React from 'react'
import { RouteComponentProps } from '@reach/router'
import styled from 'styled-components'
import WithAuthorization from '../../components/WithAuthorization/WithAuthorization'
import AllFiles from '../../components/AllFiles/AllFiles'
import CustomCard from '../../components/CustomCard/CustomCard'
import BulkOperation from '../../components/BulkOperation/BulkOperation'
import SearchHeader from '../../components/SearchHeader/SearchHeader'
interface IProps extends RouteComponentProps {
  parentUserId: string
}

class StashboardParentId extends React.Component<IProps> {
  public render() {
    const { parentUserId } = this.props
    return (
      <main>
        <CustomCard type={'allFiles'}>
          <CardHeader>
            <BulkOperation />
          </CardHeader>
          <AllFiles parentUserId={parentUserId} />
        </CustomCard>
      </main>
    )
  }
}

const CardHeader = styled.section`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 24px;
`

export default WithAuthorization(StashboardParentId, SearchHeader)
